import { actionCreatorFactory } from "typescript-fsa";
import { News } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("NewsTABLE");

const resetData = actionCreator<{data:News[]}>("NewsTABLE_RESETDATA");
const toogleEntry= actionCreator<{what:string, uuid:string}>("NewsTABLE_SETToogle")
 export const TableThingyActions = { resetData, toogleEntry}


